import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Layout, Typography, Switch, DatePicker } from 'antd';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { DashboardDateContext } from '../../contexts/DashboardDateContext';

import './Header.scss';

import { readAll } from '../../../redux/notification/notification.actions';
import { markAllOrderAsRead } from '../../services/http/PedidoService';
import {
  getUser,
  isOrganization,
  isBackOfficeOrUpgasEmployee,
} from '../../services/UserService';
import { IndexDashboardOperacaoStatusEnumToDescription } from '../../Enum/DashboardOperacaoStatusEnum';
import Notifications from '../notifications/Notifications';
import { ResaleStatusContext } from '../../contexts/ResaleStatusContext';

const { Header } = Layout;

const PAGE_TITLES = {
  '/': 'Pedidos do dia',
  '/dashboard': 'Dashboard',
  '/dashboard/operacao': 'Pedidos do dia',
  '/revendas': 'Revendas',
  '/organizacoes': 'Organizações',
  '/financas/pedidos': 'Finanças: Pedidos',
  '/financas/balancos': 'Finanças: Balanços',
  '/pedidos': 'Histórico de Pedidos',
  '/relatorios/motoristas': 'Relatório Motoristas',
  '/relatorios/revendas': 'Relatórios: Revendas',
  '/relatorios/pedidos': 'Relatórios: Pedidos',
  '/desempenho': 'Dashboard de Desempenho',
  '/usuarios': 'Usuários',
  '/cupons': 'Cupons',
  '/quadroDeAvisos': 'Quadros de Aviso',
  '/telefonesBloqueados': 'Telefones Bloqueados',
  '/motoristas': 'Motoristas',
  '/chat': 'Chat',
  '/termos-condicoes': 'Termos e Condições',
  '/indiqueGanhe': 'Indique e Ganhe',
  '/parametros-operacao': 'Parâmetros de Operação',
  '/configuracoes': 'Configurações',
};

class UpGasHeader extends React.Component {
  static contextType = ResaleStatusContext;

  state = {
    settingsVisible: false,
  };

  onMarkAllAsRead = () => {
    const { id } = getUser();
    markAllOrderAsRead(id);
    this.props.readAll();
  };

  getPageTitle = () => {
    const { location } = this.props;
    if (!location) return '';
    const { pathname } = location;
    const opMatch = pathname.match(/^\/operacao\/pedidos\/(\w+)/);
    if (opMatch)
      return IndexDashboardOperacaoStatusEnumToDescription(opMatch[1]);
    const revendaEditMatch = pathname.match(/^\/revendas\/[^/]+\/edit/);
    if (revendaEditMatch) {
      if (isBackOfficeOrUpgasEmployee() && this.context.resaleName)
        return this.context.resaleName;
      return 'Preços e Horários';
    }
    if (PAGE_TITLES[pathname]) return PAGE_TITLES[pathname];
    const match = Object.keys(PAGE_TITLES)
      .filter((key) => pathname.startsWith(key))
      .sort((a, b) => b.length - a.length)[0];
    return PAGE_TITLES[match] || '';
  };

  getBreadcrumb = () => {
    const { location } = this.props;
    if (!location) return null;
    const { pathname } = location;
    const opMatch = pathname.match(/^\/operacao\/pedidos\/(\w+)/);
    if (opMatch) {
      const statusText = IndexDashboardOperacaoStatusEnumToDescription(
        opMatch[1],
      );
      return ['Pedidos', statusText];
    }
    const revendaEditMatch = pathname.match(/^\/revendas\/[^/]+\/edit/);
    if (revendaEditMatch && isBackOfficeOrUpgasEmployee())
      return ['Revendas', 'Editar revenda'];
    return null;
  };

  render() {
    const {
      isCollapsed,
      onToggle,
      notifications,
      onNotificationClick,
      toggleSoundMute,
      muted,
    } = this.props;

    const pageTitle = this.getPageTitle();
    const breadcrumb = this.getBreadcrumb();

    return (
      <Header className='header-container'>
        <div className='menu-icon-container'>
          {isCollapsed ? (
            <MenuUnfoldOutlined className='trigger' onClick={onToggle} />
          ) : (
            <MenuFoldOutlined className='trigger' onClick={onToggle} />
          )}
          {pageTitle && (
            <div className='header-page-info'>
              <span className='header-page-title'>{pageTitle}</span>
              {breadcrumb && (
                <div className='header-breadcrumb'>
                  {breadcrumb.map((item, i) => (
                    <React.Fragment key={i}>
                      {i > 0 && (
                        <span className='header-breadcrumb-sep'> / </span>
                      )}
                      <span
                        className={`header-breadcrumb-item${i === breadcrumb.length - 1 ? ' active' : ''}`}
                        onClick={
                          i < breadcrumb.length - 1
                            ? () => this.props.history.goBack()
                            : undefined
                        }
                        style={
                          i < breadcrumb.length - 1 ? { cursor: 'pointer' } : {}
                        }>
                        {item}
                      </span>
                    </React.Fragment>
                  ))}
                </div>
              )}
            </div>
          )}
          {(this.props.location.pathname === '/' ||
            this.props.location.pathname === '/dashboard/operacao') && (
            <DashboardDateContext.Consumer>
              {({ date, setDate }) => (
                <DatePicker
                  value={date}
                  onChange={setDate}
                  format='ll'
                  allowClear={false}
                  className='header-date-picker'
                />
              )}
            </DashboardDateContext.Consumer>
          )}
        </div>
        <div className='header-options-container'>
          {isOrganization() &&
            this.props.location.pathname.match(/\/revendas\/[^/]+\/edit/) && (
            <div>
              <Typography.Text className='mr-10'>
                Status das revendas:
              </Typography.Text>
              <Switch
                checked={this.context.isAnyResaleOpen}
                onChange={this.context.closeAllResales}
                checkedChildren='Aberta'
                unCheckedChildren='Fechada'
              />
            </div>
          )}
          <div>
            <Typography.Text className='mr-10'>Sons de aviso</Typography.Text>
            <Switch checked={!muted} onChange={toggleSoundMute} />
          </div>
          <Notifications
            notifications={notifications}
            onNotificationClick={onNotificationClick}
            onMarkAllAsRead={this.onMarkAllAsRead}
          />
        </div>
      </Header>
    );
  }
}

const mapActionToProps = (dispatch) =>
  bindActionCreators({ readAll }, dispatch);

const mapStateToProps = (state) => ({ notifications: state.notifications });

UpGasHeader = connect(mapStateToProps, mapActionToProps)(UpGasHeader);

export default withRouter(UpGasHeader);
